/** Stacking order for the calendar popover so it renders above app modals (z-index 1200). */
export var POPOVER_Z_INDEX = 1300;
var INPUT = {
  backgroundColor: "var(--sds-bg-base-default)",
  borderColor: "var(--sds-border-base-secondary)",
  borderRadius: 8,
  color: "var(--sds-text-base-default)",
  cursor: "pointer",
  "&::placeholder": {
    color: "var(--sds-text-base-secondary)"
  },
  "&:focus, &:focus-within": {
    borderColor: "var(--sds-border-brand-default)"
  },
  "&:disabled, &[data-disabled]": {
    backgroundColor: "var(--sds-bg-disabled-default)",
    borderColor: "var(--sds-border-disabled-default)",
    color: "var(--sds-text-disabled-on-disabled)",
    opacity: 1,
    cursor: "not-allowed"
  }
};
var DAY = {
  color: "var(--sds-text-base-default)",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&:focus": {
    outline: "none"
  },
  "&[data-outside]": {
    color: "var(--sds-text-base-tertiary)"
  },
  "&[data-selected]": {
    "&, &:hover, &:focus": {
      backgroundColor: "var(--sds-bg-brand-default)",
      color: "var(--sds-text-brand-on-brand)"
    }
  },
  "&[data-in-range]": {
    backgroundColor: "var(--sds-bg-brand-tertiary)"
  },
  "&[data-disabled]": {
    color: "var(--sds-text-disabled-default)"
  }
};

/** Mantine styles for the trigger input, mapped onto SDS surface tokens. */
export var TRIGGER_STYLES = {
  input: INPUT
};

/** Mantine styles for the Calendar / RangeCalendar with the built-in header hidden. */
export var CALENDAR_STYLES = {
  calendarHeader: {
    display: "none"
  },
  day: DAY,
  weekday: {
    color: "var(--sds-text-base-secondary)"
  }
};

/** Mantine Popover dropdown styling for the calendar surface. */
export var POPOVER_STYLES = {
  dropdown: {
    backgroundColor: "var(--sds-bg-base-default)",
    border: "1px solid var(--sds-border-base-secondary)",
    padding: 12
  }
};

/** Mantine Select styling for the month and year dropdowns in the header. */
export var HEADER_SELECT_STYLES = {
  input: INPUT,
  dropdown: {
    backgroundColor: "var(--sds-bg-base-default)",
    borderColor: "var(--sds-border-base-secondary)"
  },
  item: {
    color: "var(--sds-text-base-default)",
    "&[data-hovered]": {
      backgroundColor: "var(--sds-bg-base-secondary)"
    },
    "&[data-selected]": {
      "&, &:hover": {
        backgroundColor: "var(--sds-bg-brand-tertiary)",
        color: "var(--sds-text-brand-default)"
      }
    }
  }
};

/** Mantine SegmentedControl styling for the By day / By month toggle. */
export var MODE_TOGGLE_STYLES = {
  root: {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  label: {
    color: "var(--sds-text-base-secondary)",
    "&[data-active]": {
      color: "var(--sds-text-base-default)"
    }
  },
  indicator: {
    backgroundColor: "var(--sds-bg-base-default)"
  }
};

/** SDS colour tokens (as CSS variables) for the whole-month grid cells. */
export var MONTH_CELL_COLORS = {
  text: "var(--sds-text-base-default)",
  edgeText: "var(--sds-text-brand-on-brand)",
  edgeBg: "var(--sds-bg-brand-default)",
  inRangeBg: "var(--sds-bg-brand-tertiary)",
  hoverBg: "var(--sds-bg-base-secondary)",
  disabledText: "var(--sds-text-disabled-default)"
};